module.exports = __webpack_public_path__ + "static/media/Muli-Bold.52c35b70.ttf";